module.exports = __webpack_public_path__ + "static/media/salesforceHero2x.f589a14f.png";